/**
 * Brand — the Alouvya logotype.
 *
 * Renders the official wordmark (logo image) by default; falls back to a serif text
 * rendering if the image fails to load. The deep-forest → warm-gold gradient comes
 * straight from the master logo asset; we never reproduce it in CSS.
 */
import { useState } from "react";

const LOGO_URL = "/brand/alouvya-wordmark-tight.svg";

const SIZES = {
  sm: { height: 22, fontSize: "text-lg" },
  md: { height: 30, fontSize: "text-xl" },
  lg: { height: 40, fontSize: "text-2xl" },
  xl: { height: 60, fontSize: "text-4xl" },
};

export default function Brand({
  size = "md",
  suffix = null,
  className = "",
  dataTestId = "brand",
}) {
  const [failed, setFailed] = useState(false);
  const cfg = SIZES[size] || SIZES.md;

  return (
    <span
      data-testid={dataTestId}
      className={"inline-flex items-center gap-2 " + className}
    >
      {failed ? (
        <span
          className={`font-serif tracking-tight text-[#1A1B2E] ${cfg.fontSize}`}
        >
          Alouvya
        </span>
      ) : (
        <img
          src={LOGO_URL}
          alt="Alouvya"
          onError={() => setFailed(true)}
          style={{ height: cfg.height, width: "auto" }}
          className="select-none object-contain"
        />
      )}
      {suffix && (
        <span
          className={`font-serif tracking-tight text-[#6A6863] ${cfg.fontSize}`}
        >
          · {suffix}
        </span>
      )}
    </span>
  );
}
